import type { Tab, TabGroupProps } from '../tab-group';
import TabGroup from '../tab-group';

export type { Tab };
export type LinkTabsProps = Omit<TabGroupProps, 'variant'>;

function LinkTabs(props: LinkTabsProps) {
  return <TabGroup variant="line" {...props} />;
}

export default LinkTabs;
